import React from 'react';
import PropTypes from 'prop-types';

const HeaderColorStateContext = React.createContext();
const HeaderColorUpdaterContext = React.createContext();

function HeaderColorProvider({ children }) {
  const [headerColor, setHeaderColor] = React.useState('transparent');
  return (
    <HeaderColorStateContext.Provider value={headerColor}>
      <HeaderColorUpdaterContext.Provider value={setHeaderColor}>
        {children}
      </HeaderColorUpdaterContext.Provider>
    </HeaderColorStateContext.Provider>
  );
}

HeaderColorProvider.propTypes = {
  children: PropTypes.node,
};

HeaderColorProvider.defaultProps = {
  children: null,
};

function useHeaderColorState() {
  const headerColorState = React.useContext(HeaderColorStateContext);
  if (typeof headerColorState === 'undefined') {
    throw new Error(
      'useHeaderColorState must be used within a HeaderColorProvider'
    );
  }
  return headerColorState;
}

function useHeaderColorUpdater() {
  const setHeaderColor = React.useContext(HeaderColorUpdaterContext);
  if (typeof setHeaderColor === 'undefined') {
    throw new Error(
      'useHeaderColorUpdater must be used within a HeaderColorProvider'
    );
  }
  return React.useCallback((color) => setHeaderColor(color), [setHeaderColor]);
}

export { HeaderColorProvider, useHeaderColorState, useHeaderColorUpdater };
